import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PAGE_META = {
  '/admin': ['Dashboard Overview', 'A live operational summary across learners, tutors, sessions, and bookings.'],
  '/admin/users': ['User Management', 'Manage learner, tutor, parent, and administrator accounts.'],
  '/admin/tutor-imports': ['Tutor Applications', 'Review submitted tutor profiles, documents, and verification outcomes.'],
  '/admin/reviews': ['Reviews', 'Monitor learner feedback and tutor review quality.'],
  '/admin/math-classes': ['Math Classes', 'Manage mathematics programme sessions and allocations.'],
  '/admin/matric-classes': ['Matric Classes', 'Manage Grade 12 sessions, learners, and delivery details.'],
  '/admin/subjects': ['Subjects', 'Maintain the curriculum-aware subject catalogue.'],
  '/admin/recordings': ['Recordings', 'Review and distribute recorded learning sessions.'],
  '/admin/bookings': ['Tutor Requests & Bookings', 'Review tutoring requests, payments, tutor responses, and session readiness.'],
  '/admin/discount-codes': ['Discount Codes', 'Create and manage booking promotions without changing tutor remuneration.'],
  '/admin/lesson-alerts': ['Lesson Alerts', 'Investigate missed lessons, no-shows, reschedules, and supporting reasons.'],
  '/admin/announcements': ['Announcements', 'Publish and track communications for Apex users.'],
  '/admin/reports': ['Reports', 'Generate and review learner and operational reports.'],
  '/admin/support': ['Support', 'Review and resolve support requests.'],
  '/admin/analytics': ['Analytics', 'Review performance, engagement, and session activity.'],
  '/admin/messages': ['Admin Messaging', 'Communicate with administrators, tutors, and parents.'],
  '/admin/message-oversight': ['Message Oversight', 'Review platform communication for safeguarding and support.'],
  '/admin/notifications': ['Messages & Notifications', 'Send targeted notifications and announcements.'],
  '/admin/settings': ['Admin Settings', 'Manage administrator preferences, security, and system controls.'],
};

const AdminPageHeader = () => {
  const { pathname } = useLocation();
  const [title, subtitle] = PAGE_META[pathname] || ['Administration', 'Manage Apex Academic Centre operations.'];
  useEffect(() => {
    document.title = `${title} | My Apex Admin`;
  }, [title]);
  return (
    <header className="admin-page-header">
      <div>
        <p className="admin-page-eyebrow">MY APEX ADMIN</p>
        <h1>{title}</h1>
        <p className="admin-page-subtitle">{subtitle}</p>
      </div>
    </header>
  );
};

export default AdminPageHeader;
